<div class="grid mt-2 ml-3 overview-details mr-0">
    <div class="col-6 md:col-12 lg:col-6 pl-0">

        <div class="card p-fluid p-3">
            <div class="flex justify-content-between flex-wrap mb-3">
                <div class="flex justify-content-center mb-3">
                    <label class="card-heading uppercase font-semibold" translate>protocol.lbl_protocol_details</label>
                </div>
                @if (isAllowToEdit) {
                <div class="edit justify-content-center mb-3 cursor-pointer"
                    [ngClass]="{'hidden': isDeleted}" (click)="redirectToEdit()">
                    <label class="card-action pr-2" translate>protocol.lbl_edit</label>
                    <i class="mi-lg edit_pencil wh-16"></i>
                </div>
                }
            </div>
            <div class="grid">
                <div class="col-4  pt-1">
                    <label class="detail-heading"
                        translate>{{cs.getLabelValue('protocol.fields.protocol_status.label',attributeLabels,'protocol_status')}}</label>
                </div>
                <div class="col-8  pb-1">
                    @for (item of attributeValues['protocol_status'] | keyvalue; track item.key) {
                    <label class="detail-value border-round-md status-box" [ngClass]="{
                        'active': item.key?.toLowerCase() === 'active',
                        'inactive': item.key?.toLowerCase() === 'inactive',
                        'draft': item.key?.toLowerCase() === 'draft',
                        'completed': item.key?.toLowerCase() === 'completed',
                        'running': item.key?.toLowerCase() === 'running',
                        'paused': item.key?.toLowerCase() === 'paused',
                        'stopped': item.key?.toLowerCase() === 'stopped'
                    }">{{ item.value }}</label>
                    }
                </div>
            </div>
            <hr class="hr-line">
            <div class="grid">
                <div class="col-4  pt-1">
                    <label class="detail-heading"
                        translate>{{cs.getLabelValue('protocol.fields.protocol_code.label',attributeLabels,'protocol_code')}}</label>
                </div>
                <div class="col-8  pb-1">
                    <label class="detail-value">{{ attributeValues['protocol_code'] ? attributeValues['protocol_code'] :
                        '--' }}</label>
                </div>
            </div>
            <hr class="hr-line">
            <div class="grid">
                <div class="col-4  pt-1">
                    <label class="detail-heading"
                        translate>{{cs.getLabelValue('protocol.fields.protocol_name.label',attributeLabels,'protocol_name')}}</label>
                </div>
                <div class="col-8  pb-1">
                    <label class="detail-value">{{ attributeValues['protocol_name'] ? attributeValues['protocol_name'] :
                        '--' }}</label>
                </div>
            </div>
            <hr class="hr-line">
            <div class="grid">
                <div class="col-4  pt-1">
                    <label class="detail-heading"
                        translate>{{cs.getLabelValue('protocol.fields.sponsor_entity_id.label',attributeLabels,'sponsor_entity_id')}}</label>
                </div>
                <div class="col-8  pb-1">
                    <label class="detail-value">{{ attributeValues['sponsor_details'] ?
                        attributeValues['sponsor_details'].sponsor_name : '--' }}</label>
                </div>
            </div>
            <hr class="hr-line">
            <div class="grid">
                <div class="col-4  pt-1">
                    <label class="detail-heading"
                        translate>{{cs.getLabelValue('protocol.fields.start_date.label',attributeLabels,'start_date')}}</label>
                </div>
                <div class="col-8  pb-1">
                    <label class="detail-value">{{ attributeValues['start_date'] ?
                        metaDataService.formatDateTimeOnTZ(attributeValues['start_date'], 'DD MMM YYYY') : '--'
                        }}</label>
                </div>
            </div>
            <hr class="hr-line">
            <div class="grid">
                <div class="col-4  pt-1">
                    <label class="detail-heading"
                        translate>{{cs.getLabelValue('protocol.fields.end_date.label',attributeLabels,'end_date')}}</label>
                </div>
                <div class="col-8  pb-1">
                    <label class="detail-value">{{ attributeValues['end_date'] ?
                        metaDataService.formatDateTimeOnTZ(attributeValues['end_date'], 'DD MMM YYYY') : '--' }}</label>
                </div>
            </div>
            <hr class="hr-line">
            <div class="grid">
                <div class="col-4  pt-1">
                    <label class="detail-heading"
                        translate>{{cs.getLabelValue('protocol.fields.estimated_participant.label',attributeLabels,'estimated_participant')}}</label>
                </div>
                <div class="col-8  pb-1">
                    <label class="detail-value">{{ attributeValues['estimated_participant'] ?
                        attributeValues['estimated_participant'] : '--' }}</label>
                </div>
            </div>
            <hr class="hr-line">
            <div class="grid">
                <div class="col-4  pt-1">
                    <label class="detail-heading"
                        translate>{{cs.getLabelValue('protocol.fields.entity_created_at.label',attributeLabels,'entity_created_at')}}</label>
                </div>
                <div class="col-8  pb-1">
                    <label class="detail-value">{{ attributeValues['entity_created_at'] ?
                        metaDataService.formatDateTimeOnTZ(attributeValues['entity_created_at'], 'DD MMM YYYY, h:mm A')
                        : '--'
                        }}</label>
                </div>
            </div>

        </div>


    </div>
    @if(!configService.isSiteUser() || configService.isSponsor()){
    <div class="col-6 md:col-12 lg:col-6">
        <div class="card p-fluid mr-2">
            <div class="flex justify-content-between flex-wrap">
                <div class="flex justify-content-center mb-3">
                    <label class="card-heading uppercase" translate>lbl_files</label>
                </div>
            </div>
            <p-tabView class="custom-files-tabview">
                <p-tabPanel>
                    <ng-template pTemplate="header">
                        <i class="mi-lg file-download wh-16"></i>
                        <label class="capitalize"><span translate>lbl_ctn</span> ({{protocolFilesTotalRecords}})</label>
                    </ng-template>
                    <div class="pt-4">
                        @for (item of protocolFilesData; track item.id) {
                        <!-- @for (file of item.protocol_file; track file.file_name) { -->
                        <div class="download-container flex align-items-center justify-content-between mb-3">
                            <div class="download-info flex align-items-center">
                                <img class="inline-block cursor-pointer flex-shrink-0" [src]="openLogo" alt="">
                                <span>{{item.file_name}}</span>
                            </div>
                            <span class="download-date">{{metaDataService.formatDateTimeOnTZ(item.entity_created_at, 'DD
                                MMM YYYY, h:mm A')}}</span>
                            <a (click)="downloadFile(item.protocol_file_url, item.file_name)">
                                <i
                                    class="{{miIcons.DOWNLOAD}} download-icon cursor-pointer inline-block wh-14 mr-2"></i>
                            </a>
                        </div>
                        <!-- } -->

                        }

                        @if (protocolFilesTotalRecords > 0) {
                        <p-paginator class="justify-content-start"
                            [dropdownAppendTo]="'body'"
                            [first]="protocolFilesPageFirst"
                            [rows]="protocolFilesPageRows"
                            [totalRecords]="protocolFilesTotalRecords"
                            [rowsPerPageOptions]="[10, 25, 50]"
                            (onPageChange)="onProtocolFilesPageChange($event)"
                            [showCurrentPageReport]="true"
                            currentPageReportTemplate="{first}-{last} of {totalRecords}"
                            [showPageLinks]="false"
                            [showFirstLastIcon]="false">
                        </p-paginator>
                        }
                        @if (protocolFilesTotalRecords === 0) {
                        <div class="w-full pt-0 pr-2 pb-0 no-result-container">
                            <app-no-result-found></app-no-result-found>
                        </div>
                        }
                    </div>
                </p-tabPanel>

                <p-tabPanel>
                    <ng-template pTemplate="header">
                        <i class="mi-lg protocol-products"></i>
                        <label class="capitalize"><span
                                translate>protocol.lbl_products_details</span>({{protocolProductFilesTotalRecords}})</label>
                    </ng-template>
                    <div class="pt-4">
                        @for (item of protocolProductFilesData; track item.id) {
                        <!-- @for (file of item.protocol_file; track file.file_name) { -->
                        <div class="download-container flex align-items-center justify-content-between mb-3">
                            <div class="download-info flex align-items-center">
                                <img class="inline-block cursor-pointer flex-shrink-0" [src]="openLogo" alt="">
                                <span>{{item.file_name}}</span>
                            </div>
                            <span class="download-date">{{metaDataService.formatDateTimeOnTZ(item.entity_created_at, 'DD
                                MMM YYYY, h:mm A')}}</span>
                            <a (click)="downloadFile(item.protocol_file_url, item.file_name)">
                                <i
                                    class="{{miIcons.DOWNLOAD}} download-icon cursor-pointer inline-block wh-14 mr-2"></i>
                            </a>
                        </div>
                        }

                        <!-- } -->
                        @if (protocolProductFilesTotalRecords > 0) {
                        <p-paginator class="justify-content-start"
                            [dropdownAppendTo]="'body'"
                            [first]="protocolProductFilesPageFirst"
                            [rows]="protocolProductFilesPageRows"
                            [totalRecords]="protocolProductFilesTotalRecords"
                            [rowsPerPageOptions]="[10, 25, 50]"
                            (onPageChange)="onProtocolProductFilesPageChange($event)"
                            [showCurrentPageReport]="true"
                            currentPageReportTemplate="{first}-{last} of {totalRecords}"
                            [showPageLinks]="false"
                            [showFirstLastIcon]="false">
                        </p-paginator>
                        }
                        @if (protocolProductFilesTotalRecords === 0) {
                        <div class="w-full pt-0 pr-2 pb-0 no-result-container">
                            <app-no-result-found></app-no-result-found>
                        </div>
                        }
                    </div>
                </p-tabPanel>
                <p-tabPanel>
                    <ng-template pTemplate="header">
                        <i class="mi-lg mi-purchase_order"></i>
                        <label class="capitalize"><span
                                translate>protocol.lbl_purchase_details</span>({{protocolPurchaseOrderFilesTotalRecords}})</label>
                    </ng-template>
                    <div class="pt-4">
                        @for (item of protocolPurchaseOrderFilesData; track item.id) {
                        <!-- @for (file of item.protocol_file; track file.file_name) { -->
                        <div class="download-container flex align-items-center justify-content-between mb-3">
                            <div class="download-info flex align-items-center">
                                <img class="inline-block cursor-pointer flex-shrink-0" [src]="openLogo" alt="">
                                <span>{{item.file_name}}</span>
                            </div>
                            <span class="download-date">{{metaDataService.formatDateTimeOnTZ(item.entity_created_at, 'DD
                                MMM YYYY, h:mm A')}}</span>
                            <a (click)="downloadFile(item.protocol_file_url, item.file_name)">
                                <i
                                    class="{{miIcons.DOWNLOAD}} download-icon cursor-pointer inline-block wh-14 mr-2"></i>
                            </a>
                        </div>
                        <!-- } -->

                        }
                        @if (protocolPurchaseOrderFilesTotalRecords > 0) {
                        <p-paginator class="justify-content-start"
                            [dropdownAppendTo]="'body'"
                            [first]="protocolPurchaseOrderFilesPageFirst"
                            [rows]="protocolPurchaseOrderFilesPageRows"
                            [totalRecords]="protocolPurchaseOrderFilesTotalRecords"
                            [rowsPerPageOptions]="[10, 25, 50]"
                            (onPageChange)="onProtocolPurchaseOrderFilesPageChange($event)"
                            [showCurrentPageReport]="true"
                            currentPageReportTemplate="{first}-{last} of {totalRecords}"
                            [showPageLinks]="false"
                            [showFirstLastIcon]="false">
                        </p-paginator>
                        }
                        @if (protocolPurchaseOrderFilesTotalRecords === 0) {
                        <div class="w-full pt-0 pr-2 pb-0 no-result-container">
                            <app-no-result-found></app-no-result-found>
                        </div>
                        }
                    </div>
                </p-tabPanel>
            </p-tabView>

        </div>
    </div>
    }
</div>